import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mantine/core';
import { useParams } from 'react-router';

const getAnimationVariants = (direction: 'left' | 'right') => ({
    initial: {
        opacity: 0,
        x: direction === 'right' ? '100%' : '-100%',
    },
    animate: {
        opacity: 1,
        x: 0,
        transition: { duration: 0.3, ease: 'easeInOut' },
    },
});

const AnimatedRoutes: React.FC = () => {
    const location = useLocation();
    const { id } = useParams();
    const previousPathname = useRef<string>(location.pathname);

    const wasIDPresent = useRef<boolean>(!!id);
    const [direction, setDirection] = useState<'left' | 'right'>('right');
    const [delayedLocation, setDelayedLocation] = useState(location);

    useEffect(() => {
        const nowHasID = !!id;
        const pathSegments = location.pathname.split('/').filter(Boolean);
        const previousSegments = previousPathname.current.split('/').filter(Boolean);
        const subRoutes = ['mmeCalculator', 'editPrescription', 'documents', 'lifeEvents', 'physicalExamination'];
        const isSubRoute = subRoutes.some(route => pathSegments.includes(route));
        const wasSubRoute = subRoutes.some(route => previousSegments.includes(route));
      
        if (isSubRoute && !wasSubRoute) 
            setDirection('right');
         else if (nowHasID && !wasIDPresent.current) 
            setDirection('right');
         else 
            setDirection('left');
        
        wasIDPresent.current = nowHasID;
        previousPathname.current = location.pathname;

        setDelayedLocation(location);
    }, [location, id]);

    const animationVariants = getAnimationVariants(direction);

    return (
        <Box p={0} pos="relative" w="100%" h="100%">
            <AnimatePresence mode="sync">
                <motion.div
                    key={delayedLocation.pathname}
                    variants={animationVariants}
                    initial="initial"
                    animate="animate"
                    style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        top: 0,
                        left: 0,
                    }}
                >
                    <Outlet />
                </motion.div>
            </AnimatePresence>
        </Box>
    );
};

export default AnimatedRoutes;
